<template>
  <div class="fangan">
    <div class="box">
      <h4 v-if="obj==='huaxia'">上海华夏移民</h4>
      <h4 v-if="obj==='xiangshun'">安徽祥舜红木</h4>
      <div v-if="obj==='huaxia'">
        <img class="yuanjiao" :src="imgUrl+'/images/huaxia_about_a.png!ty'">
        <br>
        <br>
        <p>
          2016年起华夏移民与我们保持长久技术支持合作，我方负责一切涉及网络技术的工作，先后开发了官网，手机网站，小程序，各抽活动奖页，内部ERP，海外推广系统等，其中ERP管理系统于2023年经过改版加入更多实用模块，
          使用体验得到进一步加强，大大加强了各部门工作效率。
        </p>
        <p>
          华夏移民通过全方位的技术托管服务拥有了“编外网络技术部”，公司得以全身心投入市场拓展与销售中，其中CRM系统在保护了公司客户数据资产同时也提高了市场部拓展客户的效率。
        </p>
        <p>
          全方位技术支持意味着我们是华夏的“技术部/远程办公员工”，不管任何响应或问题，只要涉及到网络方面均是我们的本职工作！经过复盘华夏每年保持着前沿的网络系统，而其费用开销仅仅是同类型公司开销的30%！
        </p>
      </div>
      <div v-if="obj==='xiangshun'">
        <p class="text-center">
          <img style="width: 200px;" :src="imgUrl+'/images/login.jpg!ty'">
        </p>
        <br>
        <p>
          2018年起，我们线后为祥舜红木搭建了官网，祥舜艺术网，内部ERP系统。其中ERP涵盖CRM与库存管理，帮助祥舜更好的管理订单合同与库存发货。
        </p>
        <p>
          通过我们祥舜每年在网络技术服务费方面的开支仅仅是同行业的15%-20%！
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';

export default {
  name: 'fangan',
  props:['obj'],
  mixins: [generalMix],
  data () {
    return {
    }
  },
  methods:{
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.fangan {
  box-shadow: 0 0 1.5rem rgba(18, 38, 63, .1);
  background: #FFFFFF;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  /*通用滚动条样式*/
  div.box{
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    h4{
      line-height: 5em;
      border-bottom: 1px solid #EFF2F7;
      margin-bottom: 50px;
    }
    div{
      width: 100%;
      img{
        width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .fangan {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/fangan.vue